import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ReturnPolicy() {
  const { t } = useTranslation("global");

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">{t('return.title')}</h2>
      <p className="text-center mb-5">{t('return.subtitle')}</p>

      <div className="mb-4">
        <h4>{t('return.conditions.title')}</h4>
        <p>{t('return.conditions.description')}</p>
      </div>

      <div className="mb-4">
        <h4>{t('return.process.title')}</h4>
        <p>{t('return.process.description')}</p>
      </div>

      <div className="mb-4">
        <h4>{t('return.contact.title')}</h4>
        <p>{t('return.contact.description')}</p>
      </div>
    </div>
  );
}
